import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage';

import { Challenge } from "../../models/challenge.model";

import { ChallengeProvider } from "../../providers/challenge/challenge";
import { LanguageProvider } from '../../providers/language/language';

import { ChallengeDetailPage } from "../challenge-detail/challenge-detail";
import { LoginPage } from '../auth/login';
import { RulesPage } from "../rules/rules";
import { TermsOfUsePage } from "../terms-of-use/terms-of-use";

import { fadeInOutAnimation } from '../../animations/fade-in-out';

@IonicPage()
@Component({
  selector: 'page-challenges',
  templateUrl: 'challenges.html',
  animations: [
    fadeInOutAnimation
  ]
})
export class ChallengesPage {

  challenges: Challenge[];
  loading: boolean;

  dateLocale: string;

  constructor(public storage: Storage, public navCtrl: NavController, public navParams: NavParams, public modalCtrl: ModalController, public translate: TranslateService, public languageProvider: LanguageProvider, public challengeProvider: ChallengeProvider) {
    this.dateLocale = this.languageProvider.getByLocale(this.translate.currentLang).code;
  }

  getChallenges() {
    this.loading = true;
    this.challengeProvider.getAll()
      .subscribe(
        challenges => this.challenges = challenges,
        error => {
          if (error.status == 401) {
            this.disconnected();
          }
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
  }

  reloadChallenges(refresher) {
    this.challengeProvider.getAll()
      .subscribe(
        challenges => this.challenges = challenges,
        error => {
          if (error.status == 401) {
            this.disconnected();
          }
          refresher.complete();
        },
        () => {
          refresher.complete();
        }
      );
  }

  openRules(challenge) {
    this.storage.get('current_brand').then((brand) => {
      let rulesModal = this.modalCtrl.create(RulesPage, { content: challenge.rules }, { cssClass: brand.name });
      rulesModal.present();
    });
  }

  openTermsOfUse() {
    this.storage.get('current_brand').then((brand) => {
      let tosModal = this.modalCtrl.create(TermsOfUsePage, { showBackBtn: true }, { cssClass: brand.name });
      tosModal.present();
    });
  }

  openDetail(challenge) {
    if (!challenge.entry_created) {
      this.navCtrl.push(ChallengeDetailPage, {
        id: challenge.id
      });
    }
  }

  disconnected() {
    this.navCtrl.setRoot(LoginPage, {
      disconnected: true
    });
  }

  ionViewDidLoad() {
    this.getChallenges();
  }

}



// WEBPACK FOOTER //
// ./src/pages/challenges/challenges.ts